class BadGateway extends Error {
    constructor(message = 'The server, while acting as a gateway or proxy, received an invalid response from an upstream server it accessed while attempting to fulfill the request.') {
      super(message)
      this.name = this.constructor.name
      this.status = 502
      Error.captureStackTrace(this, this.constructor)
    }
}

module.exports = BadGateway
